const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
//localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, '');

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  
  if (wishlist) {
    //window.history.pushState( {} , '', `?wishlistItems=${wishlist}` );
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  }
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const checkProductExists = (index, handle) => {
  var wishlist = getWishlist();
  var indexInWishlist;
  $.ajax({
    type: "GET",
    async: true,
    url: `/products/${handle}.js`,
    success: function (data) {
      populateWishlist(index, data);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      console.log(`${xhr.status} ${handle}`);
      //removeFromWishlist(handle);
      indexInWishlist = wishlist.indexOf(handle);
      wishlist.splice(indexInWishlist, 1);
      console.log('wishlist: ' + wishlist);
      console.log('indexInWishlist: ' + indexInWishlist);
    },
    dataType: "json"
  });
  return setWishlist(wishlist);
};

const removeFromWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  //var wishlistProductRemoved = wishlist.slice(indexInWishlist, 1);
  var wishlistProductRemoved = wishlist.slice(wishlist.indexOf(handle), 1);
  console.log('wishlist: ' + wishlist);
  console.log('wishlistProductRemoved: ' + wishlistProductRemoved);
  console.log('indexInWishlist: ' + indexInWishlist);
  //return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

$(document).ready(function() {
  $('#wishlistCount_Desktop').text(getWishlist().length);

  function check_cookie_name(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      return match[2];
    }
  }

  if (check_cookie_name('cookieconsent_status') == 'deny') {
    $('.wishlistProduct').hide();
    $('#wishlistContainer').hide();
  }
});